import {
  CREATE_SATUAN_SUCCESS,
  CREATE_SATUAN_FAIL,
  RETRIEVE_SATUAN_SUCCESS,
  RETRIEVE_SATUAN_FAIL,
  UPDATE_SATUAN_SUCCESS,
  UPDATE_SATUAN_FAIL,
  DELETE_SATUAN_SUCCESS,
  DELETE_SATUAN_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_SATUAN_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_SATUAN_SUCCESS:
      return payload;

    case RETRIEVE_SATUAN_FAIL:
      return [...datas];

    case UPDATE_SATUAN_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_SATUAN_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
